import pkg from "../../package.json";

interface VersionInfo {
  version?: string;
  buildEnv?: string;
  buildDate?: string;
  gitSha?: string;
}

export function composeVersionString({
  version,
  buildEnv,
  buildDate,
  gitSha,
}: VersionInfo): string {
  const resolvedVersion = version || pkg.version;
  const envShort =
    buildEnv === "development"
      ? "dev"
      : buildEnv === "production"
        ? "prod"
        : "local";
  const shortSha = gitSha ? gitSha.slice(0, 7) : undefined;

  return [`v${resolvedVersion}`, envShort, buildDate, shortSha]
    .filter(Boolean)
    .join(" · ");
}

export default function VersionBadge({ className }: { className?: string }) {
  const versionString = composeVersionString({
    version: import.meta.env.VITE_APP_VERSION,
    buildEnv: import.meta.env.VITE_BUILD_ENV,
    buildDate: import.meta.env.VITE_BUILD_DATE,
    gitSha: import.meta.env.VITE_GIT_SHA,
  });

  return (
    <span
      data-testid="app-version"
      className={[
        "fixed bottom-2 right-3 text-[10px] font-mono text-slate-400 pointer-events-none select-none z-50",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {versionString}
    </span>
  );
}
